export default "__VITE_ASSET__o65Z0dzT__"